import { render, staticRenderFns } from "./TablaSiniestralProduccionLineaNegocio.vue?vue&type=template&id=4cbcddf7"
import script from "./TablaSiniestralProduccionLineaNegocio.vue?vue&type=script&lang=js"
export * from "./TablaSiniestralProduccionLineaNegocio.vue?vue&type=script&lang=js"
import style0 from "./TablaSiniestralProduccionLineaNegocio.vue?vue&type=style&index=0&id=4cbcddf7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports